import { p as e, q as r, r as E, s as L } from "./variables-x6F5JYca.js";
var n = ((a) => (a[a.DEFAULT = parseInt(e, 10)] = "DEFAULT", a[a.MEDIUM = parseInt(r, 10)] = "MEDIUM", a[a.LARGE = parseInt(E, 10)] = "LARGE", a[a.XLARGE = parseInt(L, 10)] = "XLARGE", a))(n || {});
export {
  n as B
};
